var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBackgroundSpark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 304,
    height: 453,
    viewBox: "0 0 304 453",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M96.9677 285.612H15.5241C9.39882 285.612 4.86645 282.864 1.92703 277.369C-1.01239 271.875 -0.589048 266.503 3.19707 261.255L177.671 8.01901C180.256 4.53086 183.488 2.13847 187.366 0.841847C191.244 -0.454372 195.123 -0.253718 199.001 1.44381C202.879 2.98723 205.949 5.58027 208.212 9.22293C210.474 12.8656 211.282 16.755 210.636 20.8913L189.536 189.3H288.247C294.926 189.3 299.635 192.248 302.375 198.144C305.114 204.04 304.391 209.612 300.205 214.86L108.002 446.148C105.416 449.39 102.084 451.497 98.006 452.469C93.9278 453.441 90.1497 453.078 86.6717 451.381C83.0396 449.837 80.2308 447.321 78.2453 443.833C76.2603 440.345 75.514 436.455 76.0066 432.164L96.9677 285.612Z",
    fill: "url(#paint0_linear_119_1300)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_119_1300",
    x1: 152,
    y1: 0,
    x2: 152,
    y2: 453,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CACAFF",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackgroundSpark);
export default __webpack_public_path__ + "static/media/BackgroundSpark.95b571691f01e50c9d08026050d274ce.svg";
export { ForwardRef as ReactComponent };